import { Injectable } from '@angular/core';
import { Deal } from '../models/classes/deal.class';
import { Holding } from '../models/classes/holding.class';

@Injectable({
  providedIn: 'root'
})
export class TableLogicService {
  sortDataForSeriesTable<T extends { name: string; priority?: number }>(investmentTypeData: T[]): T[] {
    //sort by investment type name in priority
    investmentTypeData.forEach((invType) => {
      switch (invType.name) {
        case "Primary Investments": {
          invType['priority'] = 1;
          break;
        }
        case "Co-investments/Directs": {
          invType['priority'] = 2;
          break;
        }
        case "Secondary Investments": {
          invType['priority'] = 3;
          break;
        }
        case "Joint Ventures": {
          invType['priority'] = 4;
          break;
        }
        case "Seeds": {
          invType['priority'] = 5;
          break;
        }
        case "Working Capital Line": {
          invType['priority'] = 6;
          break;
        }
        default: {
          invType['priority'] = 7;
          break;
        }
      }
    })
    const sortedByPriority = investmentTypeData.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))
    // if a priority type is missing (e.g., priorities are [2, 3] or [1,3,4]) update priorities to be numerical starting from 1)
    let priority = 1;
    sortedByPriority.forEach((invType) => {
      invType['priority'] = priority;
      priority += 1;
    })
    return sortedByPriority;
  }

  sortDealsByCommitmentDate<T extends { name: string; earliestCommitmentDate: Date | null }>(deals: T[]): T[] {
    // Deals with no commitment date sort after every dated deal.
    return [...deals].sort((a, b) => {
      if (!a.earliestCommitmentDate && !b.earliestCommitmentDate) return a.name.localeCompare(b.name);
      if (!a.earliestCommitmentDate) return 1;
      if (!b.earliestCommitmentDate) return -1;

      const toMonthYear = (date: Date) => new Date(date).getFullYear() * 12 + new Date(date).getMonth();
      const dateDiff = toMonthYear(a.earliestCommitmentDate) - toMonthYear(b.earliestCommitmentDate);
      return dateDiff !== 0 ? dateDiff : a.name.localeCompare(b.name);
    });
  }

  checkDealToHoldingMapping(holdings: Holding[]) {
    if (holdings.length !== 0) {
      return holdings.length === 1 ? false : true;
    }
    else {
      return false;
    }
  }

  isDealDrillThroughDisabled(deal: Deal) {
    if (!deal?.investmentType) {
      return true;
    }

    return ['FX HEDGE', 'REVENUE SHARE'].includes(deal.investmentType.trim().toUpperCase());
  }
}
